const projects = [
    {
        'id': 1,
        'name': 'Creative Agency',
        'ui': 'https://i.ibb.co/1Z1SgbB/creative-agency.jpg',
        'description': 'Creative Agency is a full stack web app where you done your project by professionals',
        'github': 'https://github.com/sajjadhussains/creating-agency-client-site',
        'web': 'https://creative-agency-client-c5b20.firebaseapp.com/?fbclid=IwAR39V5z8TdNY2h_Y4ttNNAAbmOhIDUIRXPqeITBd97VhMUUeBupipAebd5M',
    },
    {
        'id': 2,
        'name': 'Ema-John E-Commerce',
        'ui': 'https://i.ibb.co/hY25R6v/ema-john.jpg',
        'description': 'Ema-John E-Commerce is a full stack web app where you can buy product using credits card',
        'github': 'https://github.com/sajjadhussains/ema-john-with-auth-master',
        'web': 'https://hardcore-murdock-b65c2e.netlify.app/',
    },
    {
        'id': 3,
        'name': 'Travel Guru',
        'ui': 'https://i.ibb.co/09xpD9z/Booking.png',
        'description': 'Travel Guru is a web app where you can book hotel for your upcoming tour',
        'github': 'https://github.com/sajjadhussains/travel-guru-site',
        'web': 'https://stoic-goldwasser-a69358.netlify.app/?fbclid=IwAR2dQ_IEEB0H2XqpWdvJNJ1psFXYNrbYcg-qL-Gh0zucVkCB_wzCWxeyER8',
    },
    {
        'id': 4,
        'name': 'Volunteer Network',
        'ui': 'https://i.imgur.com/yOWOxUu.jpg',
        'description': 'Volunteer network is a fullstack web app where  user can register as volunteer by login ',
        'github': 'https://github.com/sajjadhussains/volunteer-activities-client',
        'web': 'https://happy-roentgen-74ab58.netlify.app',
    },
    {
        'id': 5,
        'name': 'Panda Commerce',
        'ui': 'https://i.imgur.com/sR7ImgX.jpg',
        'description': 'This is a static website using html,css and bootstrap',
        'github': 'https://github.com/sajjadhussains/panda-commerce',
        'web': 'https://sajjadhussains.github.io/panda-commerce/',
    },
   
];

export default projects;